import * as actions from './actionsTypes';

const initialState = {
  isLoadingSearch: false,
  recordsCount: 0,
  searchResults: [],
  searchFail: null,
};

// Reducer de SelectSearch
const selectSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.IS_LOADING_SEARCH:
      return {
        ...state,
        isLoadingSearch: action.payload
      };
    case actions.GET_SEARCH:
      return {
        ...state,
        recordsCount: action.payload.recordsCount,
        searchResults: action.payload.data
      };
    case actions.FAIL_SEARCH:
      return {
        ...state,
        searchFail: action.payload
      };
    default:
      return state;
  }
};

export default selectSearchReducer;